// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --winterColor: #9E0505;
  --summerColor: #19398E;
}

ion-toggle {
  margin: 0 10px;
  --track-background: var(--summerColor);
  --track-background-checked: var(--winterColor);
}

.labels {
  display: flex;
  justify-content: space-between;
  height: auto;
  margin-block: 10px 5px;
}
.labels.fancoil-command {
  margin-inline: 4px;
}
.labels ion-icon,
.labels span {
  font-size: 27px;
  font-weight: 600;
  color: var(--ion-color-medium-tint);
}
.labels ion-icon.active,
.labels span.active {
  color: var(--summerColor);
}

.container-hvac-command,
.container-hvac-labels {
  margin-inline: auto;
  display: flex;
  flex-direction: column;
}

.container-hvac-command {
  margin-inline: 16px;
}

.isWinter .label-mode,
.isWinter ion-icon.active,
.isWinter span.active {
  color: var(--winterColor);
}

.icon-season {
  width: 27px;
  height: 27px;
}
.icon-season.summer {
  color: #f9ca24;
}
.icon-season.winter {
  color: #3498db;
}

.container-season-command,
.container-automan-fancoil-command {
  display: flex;
  justify-content: center;
  align-items: center;
}

.container-season > *:first-child,
.container-fancoil > *:first-child,
.container-all-setpoint > *:first-child {
  margin-block-start: 50px;
}

.container-setpoint,
.container-automan-fancoil,
.container-hvac-labels {
  margin-block-start: 30px;
}

.title-label {
  text-transform: uppercase;
  font-size: 14px;
  color: #8b8b8b;
  font-weight: 700;
  text-align: center;
  margin-bottom: 10px;
}

.label-mode {
  align-self: center;
  text-transform: uppercase;
  font-weight: 700;
  color: var(--summerColor);
  margin-block-start: 5px;
  font-size: 20px;
}

@media screen and (min-width: 400px) {
  .container-hvac-labels {
    width: calc(100% - 80px);
    margin-inline: auto;
  }
  .labels.fancoil-command {
    width: calc(100% - 40px);
    margin-inline: auto;
  }
  app-draggable-slider:not(.hvac-mode) {
    margin-inline: 16px;
  }
  .container-hvac-command {
    margin-inline: 54px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/thermostat/thermostat-expanded-section/thermostat-expanded-section.component.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,cAAA;EACA,sCAAA;EACA,8CAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,YAAA;EACA,sBAAA;AACJ;AACI;EACI,kBAAA;AACR;AAEI;;EAEI,eAAA;EACA,gBAAA;EACA,mCAAA;AAAR;AAEQ;;EACI,yBAAA;AACZ;;AAIA;;EAEI,mBAAA;EACA,aAAA;EACA,sBAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAMI;;;EAGI,yBAAA;AAHR;;AAOA;EACI,WAAA;EACA,YAAA;AAJJ;AAMI;EACI,cAAA;AAJR;AAOI;EACI,cAAA;AALR;;AASA;;EAEI,aAAA;EACA,uBAAA;EACA,mBAAA;AANJ;;AASA;;;EAGI,wBAAA;AANJ;;AASA;;;EAGI,wBAAA;AANJ;;AASA;EACI,yBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AANJ;;AASA;EACI,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;AANJ;;AASA;EAEI;IACI,wBAAA;IACA,mBAAA;EAPN;EAUE;IACI,wBAAA;IACA,mBAAA;EARN;EAWE;IACI,mBAAA;EATN;EAYE;IACI,mBAAA;EAVN;AACF","sourcesContent":[":host {\n    --winterColor: #9E0505;\n    --summerColor: #19398E;\n}\n\nion-toggle {\n    margin: 0 10px;\n    --track-background: var(--summerColor);\n    --track-background-checked: var(--winterColor);\n}\n\n.labels {\n    display: flex;\n    justify-content: space-between;\n    height: auto;\n    margin-block: 10px 5px;\n\n    &.fancoil-command {\n        margin-inline: 4px;\n    }\n\n    ion-icon,\n    span {\n        font-size: 27px;\n        font-weight: 600;\n        color: var(--ion-color-medium-tint);\n\n        &.active {\n            color: var(--summerColor);\n        }\n    }\n}\n\n.container-hvac-command,\n.container-hvac-labels {\n    margin-inline: auto;\n    display: flex;\n    flex-direction: column;\n}\n\n.container-hvac-command {\n    margin-inline: 16px;\n}\n\n.isWinter {\n\n    .label-mode,\n    ion-icon.active,\n    span.active {\n        color: var(--winterColor);\n    }\n}\n\n.icon-season {\n    width: 27px;\n    height: 27px;\n\n    &.summer {\n        color: #f9ca24;\n    }\n\n    &.winter {\n        color: #3498db;\n    }\n}\n\n.container-season-command,\n.container-automan-fancoil-command {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.container-season>*:first-child,\n.container-fancoil>*:first-child,\n.container-all-setpoint>*:first-child {\n    margin-block-start: 50px;\n}\n\n.container-setpoint,\n.container-automan-fancoil,\n.container-hvac-labels {\n    margin-block-start: 30px;\n}\n\n.title-label {\n    text-transform: uppercase;\n    font-size: 14px;\n    color: #8b8b8b;\n    font-weight: 700;\n    text-align: center;\n    margin-bottom: 10px;\n}\n\n.label-mode {\n    align-self: center;\n    text-transform: uppercase;\n    font-weight: 700;\n    color: var(--summerColor);\n    margin-block-start: 5px;\n    font-size: 20px;\n}\n\n@media screen and (min-width: 400px) {\n\n    .container-hvac-labels {\n        width: calc(100% - 80px);\n        margin-inline: auto;\n    }\n\n    .labels.fancoil-command {\n        width: calc(100% - 40px);\n        margin-inline: auto;\n    }\n\n    app-draggable-slider:not(.hvac-mode) {\n        margin-inline: 16px;\n    }\n\n    .container-hvac-command {\n        margin-inline: 54px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
